var map = {
	"./blog-1.jpg": 1625,
	"./blog-2.jpg": 8478,
	"./blog-3.jpg": 5301,
	"./blog-4.jpg": 383,
	"./blog-5.jpg": 57,
	"./blog-6.jpg": 1340,
	"./blog-7.jpg": 874,
	"./blog-8.jpg": 7704,
	"./blog-9.jpg": 243,
	"./blog-single.jpg": 1029,
	"./comment-1.jpg": 8960,
	"./comment-2.jpg": 8935,
	"./comment-3.jpg": 7840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9773;